import { arabNumberToRoman } from '../../../utils/arabNumberToRoman'
import './CarRank.css'
export const CarRank = (props: {rank: number, style?: React.CSSProperties}) => {
    
    return (
        <div className="car-rank" style={props.style}>
            <p>{arabNumberToRoman(props.rank)}</p>
        </div>
    )
}